module.exports = "<span class=\"receipt-rewards-price\">\r\n    <sup class=\"receipt-rewards-price__dollar-sign\">$</sup>\r\n    <span class=\"receipt-rewards-price__dollar\">{{vm.dollar}}</span>\r\n    <sup \r\n        ng-if=\"vm.cents > 0\"\r\n        class=\"receipt-rewards-price__cents\"\r\n    >{{vm.cents}}</sup>\r\n</span>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/receipt-rewards/receipt-rewards-price.html
 ** module id = 978
 ** module chunks = 1
 **/